import React, { memo } from 'react';
import PropTypes from 'prop-types';

const BathsThick = ({ color, ...props }) => (
  <svg viewBox="0 0 24 24" {...props}>
    <g
      stroke={color}
      strokeWidth={props.strokeWidth || 1.25}
      fillOpacity="0"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    >
      <path d="M13.5 14.5h10c0 4.971-4.029 9-9 9h-5c-4.971 0-9-4.029-9-9h6M17.271 2.361l.901-.902c.588-.523 1.429-.652 2.148-.33.718.323 1.18 1.037 1.18 1.825v11.546" />
      <path d="M17.271 5.714c.926-.926.926-2.427 0-3.353-.925-.926-2.426-.926-3.352 0l-.559.559 3.352 3.353.559-.559z" />
      <path
        strokeLinecap="round"
        d="M11.408 3.581l-1.816.838M15.893 8.08l-.786 1.84M13.211 6.297l-1.422 1.406"
      />
      <path
        strokeLinecap="round"
        d="M13.5 13.5c0-.552-.448-1-1-1h-5c-.552 0-1 .448-1 1v6h7v-6z"
      />
    </g>
  </svg>
);

BathsThick.defaultProps = {
  width: 40,
  height: 40,
  color: 'currentColor',
};

BathsThick.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default memo(BathsThick);
